module.exports = __webpack_public_path__ + "images/assets/c92202a6dcb0f4c31e594c3cb11fda01.svg";